import { render } from "./HeartRate.vue?vue&type=template&id=435c6fdb"
import script from "./HeartRate.vue?vue&type=script&lang=ts"
export * from "./HeartRate.vue?vue&type=script&lang=ts"
script.render = render

export default script